import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getDefaultPeriod } from "../../components/Filters";

export type RelatorioExportTipo =
  | "entregas_concluidas"
  | "com_comprovante"
  | "sem_comprovante";

export interface RelatorioAppliedFilters {
  dataInicial: string;
  dataFinal: string;
}

export interface TransportadorOfensor {
  id: string;
  nome: string;
  total: number;
  semComprovante: number;
  percentual: number;
}

export interface MetricData {
  total: number;
  variacao: number;
  percentualDeVariacao: number;
}

export interface ComparativoDiario {
  data: string;
  totalEntregas: number;
  comprovantesNaoRecebidos: number;
}

export interface RelatorioData {
  entregasConcluidas: MetricData;
  comComprovante: MetricData;
  semComprovante: MetricData;
  taxaComComprovantes: number;
  topTransportadoresOfensores: TransportadorOfensor[];
  comparativoDiario: ComparativoDiario[];
}

export interface RelatorioState {
  data: RelatorioData;
  error: string | null;
  appliedFilters: RelatorioAppliedFilters;
  headersCsv: { label: string; key: string; encrypted: boolean }[];
  configTabs: {
    tabInView: number;
    tabs: {
      title: string;
      index: number;
      active: boolean;
      name: string;
    }[];
  };
}

export type InitialStateSelector = {
  relatorioComprovantesApp: { relatorioComprovantes: RelatorioState };
};

const initialState: RelatorioState = {
  data: {
    entregasConcluidas: {
      total: 0,
      variacao: 0,
      percentualDeVariacao: 0,
    },
    comComprovante: {
      total: 0,
      variacao: 0,
      percentualDeVariacao: 0,
    },
    semComprovante: {
      total: 0,
      variacao: 0,
      percentualDeVariacao: 0,
    },
    taxaComComprovantes: 0,
    comparativoDiario: [],
    topTransportadoresOfensores: [],
  },
  error: null,
  appliedFilters: getDefaultPeriod(),
  headersCsv: [
    { label: "PEDIDO", key: "pedido", encrypted: false },
    { label: "CLIENTE", key: "cliente", encrypted: false },
    { label: "BU", key: "unidadeNegocio", encrypted: false },
    { label: "TIPO", key: "tipo", encrypted: false },
    { label: "TRANSPORTADORA", key: "transportadoraNome", encrypted: false },
    { label: "CNPJ", key: "transportadoraCnpj", encrypted: false },
    { label: "DATA ENT", key: "entData", encrypted: false },
    { label: "HR ENTREGA", key: "entHora", encrypted: false },
    { label: "DATA COMPROV", key: "comprovanteData", encrypted: false },
    { label: "HR COMPR", key: "comprovanteHora", encrypted: false },
    { label: "DADOS RECEB", key: "dadosRecebedor", encrypted: false },
  ],
  configTabs: {
    tabInView: 0,
    tabs: [
      {
        title: "Relatório",
        index: 0,
        active: true,
        name: "relatorio",
      },
    ],
  },
};

const relatorioSlice = createSlice({
  name: "relatorioComprovantesApp/relatorioComprovantes",
  initialState,
  reducers: {
    changeTab: (state, action: PayloadAction<number>) => {
      state.configTabs.tabInView = action.payload;
    },
    setRelatorioData: (state, action: PayloadAction<RelatorioData>) => {
      state.data = action.payload;
      state.error = null;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setAppliedFilters: (
      state,
      action: PayloadAction<RelatorioAppliedFilters>
    ) => {
      state.appliedFilters = action.payload;
    },
  },
});

export const { changeTab, setRelatorioData, setError, setAppliedFilters } =
  relatorioSlice.actions;

export default relatorioSlice.reducer;
